import "#webapp/src/components/pricing-dialog/PricingDialog.gql";
import { graphql } from "react-relay";
import "../tutorial-tip/tutorial-feed-scheduler/TutorialFeedScheduler.gql";

export const chromeWrapperFragments = {
  viewer: graphql`
    fragment ChromeWrapper_viewer on Viewer {
      ...ChromeLogin_viewer
      ...ChromeMenuDrawer_viewer
      user {
        ...ChromePersonalCalendar_user
        ...TutorialBox_user
        ...TutorialFeedScheduler_user
        id
        status
        emails
        givenName
        familyName
        createdTime
        rolloutProperties
        members {
          value
          scope {
            type
            value
          }
        }
        webAppFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
        chromeExtensionFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }

        # FLOWSTATES
        flowStates(first: 1000000) {
          edges {
            node {
              ...FastCrawlLoader_flowState
              ...FlowStatePoller_flowState
              id
              flowKey
              previousState
              current {
                state
                percentComplete
                errorMessage
              }
              pending {
                state
                percentComplete
                errorMessage
              }
            }
          }
        }

        # DATASOURCES
        dataSources(first: 1000000) {
          edges {
            node {
              id
              state
              type
              name
            }
          }
        }

        # ORG
        orgs(first: 1000000) {
          edges {
            node {
              ...ChromePersonalCalendar_org
              ...PricingDialog_org
              ...ChromeCreateEvent_org @arguments(calendarIds: [])
              id
              name
              domains
              createdTime
              crawlTest
              ecosystem
              billingGroups {
                ... on BillingGroupList {
                  list {
                    id
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
              }
              featureGrid {
                __typename
                ... on FeatureGrid {
                  featureStates {
                    freePaidFeatures {
                      autopilotWhenOrganizerCurrentlyAllowed
                      moveRangesEnabled
                    }
                    planTierFeatures {
                      paymentStatusBadge {
                        text
                        type
                      }
                    }
                    meetingReliefSettingVisibility
                  }
                  stateMetadata {
                    primaryBillingGroupMetadata {
                      subscription {
                        id
                        type
                        productType
                      }
                      billingGroup {
                        id
                      }
                    }
                    userMetadata {
                      person {
                        primaryCalendarId
                      }
                      trialMetadata {
                        trialEndDate
                        timeZone
                        isTrialExpired
                      }
                    }
                  }
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              experiments
              primaryOrgEmail
              primaryOrgCalendar
              workingGroups(first: 1000000) {
                edges {
                  node {
                    calendarIds
                  }
                }
              }
              pendingInvites(first: 1000000) {
                edges {
                  node {
                    id
                    targetCalendarId
                  }
                }
              }
              currentOrgPersons {
                __typename
                ... on OrgPersonList {
                  list {
                    primaryCalendarId
                    userId
                  }
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              userWorkingHours(resolveOverrides: false) {
                workingHours {
                  id
                  type
                  timeZone
                  daySettings {
                    day
                    setting {
                      minSlot
                      maxSlot
                      excludedSlots
                    }
                  }
                  dayOverrides {
                    date
                    setting {
                      minSlot
                      maxSlot
                      excludedSlots
                    }
                  }
                }
              }
              orgMeetingHours {
                workingHours {
                  timeZone
                }
              }
              shadowCalendarSettingsErrorable {
                __typename
                ... on ShadowCalendarSettings {
                  enabled
                  shadowCalendarId
                  focusTimeIdealMinutesPerWeek
                  focusTimeSyncEnabled
                  focusTimeSyncAll
                }
              }
              flowStates(first: 1000000) {
                edges {
                  node {
                    ...FastCrawlLoader_flowState
                    ...FlowStatePoller_flowState
                    id
                    flowKey
                    previousState
                    current {
                      state
                      percentComplete
                      errorMessage
                    }
                    pending {
                      state
                      percentComplete
                      errorMessage
                    }
                  }
                }
              }
              primaryTeam {
                __typename
                ... on Team {
                  teamId
                  teamName
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              userTeams {
                __typename
                ... on TeamList {
                  list {
                    teamId
                    teamCalendarId
                    userSettings {
                      __typename
                      ... on TeamUserSettings {
                        useTeamCalendar
                      }
                    }
                    settings {
                      __typename
                      ... on TeamSettings {
                        manageTeamCalendar
                      }
                    }
                  }
                }
              }
              userGoals(first: 1000000) {
                edges {
                  node {
                    id
                    goalId
                    name
                    isDeleted
                    options {
                      specificOptions {
                        ... on GoalWithinDayOptions {
                          minTimeSlot
                          maxTimeSlot
                          minimumDuration
                          idealDuration
                        }
                        ... on GoalWithinWeekOptions {
                          maxMinutesPerBlock
                        }
                        ... on GoalMeetingReliefOptions {
                          fatigueThresholdMinutes
                          meetingReliefBreakMinutes
                        }
                      }
                    }
                  }
                }
              }
              ...EventColoringSettings_org
              eventColoringSettingsErrorable {
                __typename
                ... on GraphEntityError {
                  statusCode
                  message
                }
                ... on EventColoringSettings {
                  eventCategoryColorings {
                    ...EventCategoryColoring_eventCategoryColoring
                    googleColorKey
                    eventCategory
                    active
                    isUserSet
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const chromeWrapperQuery = graphql`
  query ChromeWrapperQuery {
    viewer {
      ...ChromeWrapper_viewer
    }
  }
`;
